import React from 'react';
import { useLanguage } from '../utils/useLanguage';

/**
 * Global pull-quote style — no box, no border, no shadow.
 * Decorative quotation marks sit behind the text in emerald-50.
 * Used in About, Magazine content blocks, and the activity QuoteSlider.
 */
export default function PullQuote({ children, author, className = '' }) {
  const { language } = useLanguage();
  // German low-9 opening mark, English upright
  const openMark = language === 'en' ? '\u201C' : '\u201E';
  const closeMark = '\u201C';

  return (
    <figure className={`relative py-6 pl-4 sm:pl-6 min-h-[140px] flex flex-col justify-center ${className}`}>
      <span
        aria-hidden="true"
        className="absolute -top-6 left-2 leading-none select-none pointer-events-none font-heading text-emerald-200 text-6xl sm:text-7xl md:text-8xl"
      >
        {openMark}
      </span>
      <blockquote className="relative z-10">
        <p className="font-heading text-xl sm:text-2xl md:text-3xl font-medium text-gray-900 leading-relaxed">
          {children}
        </p>
        {author && (
          <figcaption className="mt-4 text-gray-500 text-sm sm:text-base">
            {author}
          </figcaption>
        )}
      </blockquote>
    </figure>
  );
}